// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.BSYKj{display:flex;flex-direction:column;height:250px;width:232px;margin:20px 0 20px 32px}.VaGDE{width:100%;padding:12px;display:flex;flex-direction:column;align-items:flex-start}.AbdPR{max-width:100%}.OIJjE{display:flex;width:100%;justify-content:space-between;align-items:center;margin-top:20px}.BqhaN{pointer-events:none}.RnF4v{display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `BSYKj`,
	"description": `VaGDE`,
	"title": `AbdPR`,
	"durationRow": `OIJjE`,
	"thumbnail": `BqhaN`,
	"vidoesContainer": `RnF4v`
};
export default ___CSS_LOADER_EXPORT___;
